/*
 * Cart: betaalmethode-iconen op één regel. Past niet alles, dan worden de
 * laatste iconen verborgen en toont een vakje "+N" hoeveel er nog zijn.
 * Rekent opnieuw bij elke breedtewijziging; na een cart-update wordt de
 * snippet opnieuw gerenderd, waardoor connectedCallback weer draait.
 */
if (!customElements.get('payment-icons-overflow')) {
  class PaymentIconsOverflow extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.wt-cart__payment-icons');
      if (!this.list) return;
      this.items = Array.from(this.list.children);
      this.more = document.createElement('li');
      this.more.className = 'wt-cart__payment-icons__more';
      this.classList.add('is-ready');
      this.observer = new ResizeObserver(() => this.fit());
      this.observer.observe(this);
      this.fit();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    overflows() {
      return this.list.scrollWidth > this.list.clientWidth + 1;
    }

    fit() {
      this.items.forEach((item) => (item.hidden = false));
      this.more.remove();
      if (!this.overflows()) return;

      this.list.appendChild(this.more);
      let hidden = 0;
      for (let i = this.items.length - 1; i > 0; i--) {
        this.items[i].hidden = true;
        hidden++;
        this.more.textContent = `+${hidden}`;
        this.more.setAttribute('aria-label', `+${hidden}`);
        if (!this.overflows()) break;
      }
    }
  }
  customElements.define('payment-icons-overflow', PaymentIconsOverflow);
}
